import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import MusicBars from "../../components/animation/MusicBars";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import PauseRoundedIcon from "@mui/icons-material/PauseRounded";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";
import { playNewSong, setplay } from "../../redux/actions/player";
import { setselectedAddPlaylist } from "../../redux/actions/music";
import ButtonTransparent from "../../components/button/ButtonTransparent";
import SearchIcon from "@mui/icons-material/Search";
import TooltipPrimary from "../../components/tooltips/TooltipPrimary";
import noMusicImg from "../../media/images/no-music-2.png";
import ShareRoundedIcon from "@mui/icons-material/ShareRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import ShowChartRoundedIcon from "@mui/icons-material/ShowChartRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";

const Playlist = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { playlistRef } = useParams();
  const { playlistMusic } = useSelector((state) => state.music);
  const { currentSong, play } = useSelector((state) => state.player);
  const [menuActive, setmenuActive] = useState(false);

  function onClickPlay(song) {
    dispatch(playNewSong(song));
    dispatch(setplay(true));
  }

  useEffect(() => {
    setmenuActive(false);
  }, [playlistRef]);

  return (
    <div className="playlist-page">
      <div className="banner">
        <div className="left">
          <div className="img">
            <img src={noMusicImg} alt="no music" />
          </div>
          <div className="desc">
            <h1>{playlistMusic[playlistRef].name}</h1>
            <p className="playlist-text">Playlist</p>
          </div>
        </div>
        <div className="right">
          <div className="icons">
            <TooltipPrimary text="Share" className="icon mr-2">
              <ShareRoundedIcon />
            </TooltipPrimary>
            <div className="menu-container">
              <TooltipPrimary
                text="More"
                className={`icon ${menuActive ? "icon-active" : ""}`}
                onClick={() => setmenuActive(!menuActive)}
              >
                <MoreVertRoundedIcon />
              </TooltipPrimary>
              {menuActive && (
                <>
                  <div className="bg-transparent" onClick={() => setmenuActive(false)} />

                  <div className="menu">
                    <div className="item">
                      <EditRoundedIcon />
                      <p>Edit playlist</p>
                    </div>
                    <div className="item">
                      <ShowChartRoundedIcon />
                      <p>Promote playlist</p>
                    </div>
                    <div className="item">
                      <DeleteRoundedIcon />
                      <p>Delete playlist</p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {playlistMusic[playlistRef].music.length ? (
        <div className="songs">
          {playlistMusic[playlistRef].music.map((item) => (
            <div key={item.name + item.artist} className="card">
              <img src={item.img} alt="justin bieber" />
              <div className="details">
                <h3>{item.name}</h3>
                <p>{item.artist}</p>
              </div>
              <div className="actions">
                {play && currentSong.name === item.name ? <MusicBars /> : <p className="time">{item.duration}</p>}
                {play && currentSong.name === item.name ? (
                  <TooltipPrimary text="Pause" className="icon pause-btn" onClick={() => dispatch(setplay(false))}>
                    <PauseRoundedIcon />
                  </TooltipPrimary>
                ) : (
                  <TooltipPrimary text="Play" className="icon play-btn" onClick={() => onClickPlay(item)}>
                    <PlayArrowRoundedIcon />
                  </TooltipPrimary>
                )}
                <TooltipPrimary text="Remove from playlist" className="icon playlist-add" onClick={() => null}>
                  <PlaylistRemoveIcon />
                </TooltipPrimary>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="empty">
          <h3>Your playlist is empty</h3>
          <ButtonTransparent text="Explore" iconLeft={<SearchIcon />} onClick={() => navigate("/search")} />
        </div>
      )}
    </div>
  );
};

export default Playlist;
